import _ from 'lodash'
import PAID_LEAVE from './constants'

export const selectJurisdiction = (sourceType, currentType) => {
  const sourceValue = PAID_LEAVE.JURISDICTIONS[sourceType]
  const currentValue = PAID_LEAVE.JURISDICTIONS[currentType]
  return sourceValue <= currentValue ? sourceType : currentType
}

export const sortByProductOrder = (list) => {
  const productsIds = PAID_LEAVE.PRODUCTS.map((product) => product.id)
  const sortedList = _.sortBy(list, (a, b) => productsIds.indexOf(a) - productsIds.indexOf(b))
  return sortedList
}

export const getPaidLeaveEnumValue = (typeString) => {
  let result = {}
  Object.getOwnPropertyNames(PAID_LEAVE.TYPES)
    .forEach((type) => {
      if (PAID_LEAVE.TYPES[type].JSON_VALUE === typeString || PAID_LEAVE.TYPES[type].PRETTY_PRINT === typeString) {
        result = PAID_LEAVE.TYPES[type]
      }
    })

  return result
}

export const getProductById = (productId) => {
  const product = PAID_LEAVE.PRODUCTS.filter((product) => product.id === productId)
  return product.length > 0 ? product[0] : null
}

export const getCompanyId = () => {
  const companyData = JSON.parse(global.sessionStorage.company)

  return companyData._id
}

export const getCompanyDisplayName = () => {
  const companyData = JSON.parse(global.sessionStorage.company)

  return companyData.displayName
}
